module.exports = __webpack_public_path__ + "img/idle-dj-details4.eca28f12.png";